
<a
	*ngIf="getRoute(currentTaxonomyPage$ | push) as route" 
	class="link" 
	[routerLink]="route.url" 
	[queryParams]="clearParams((route$ | push).queryParams)"
	title="zpět na stránku {{route.entityLabel}}"
>
	<app-icon class="icon circle-line" name="chevronLeft" [shadow]="true" [class.disabled]="!showIcon" ></app-icon>
	<span class="label">
		{{route.entityLabel}}
	</span>
	<span class="under-line-container" ></span>
	<span class="ripple-container" matRipple ></span>
</a>


